export default "__VITE_ASSET__fff50773__"